import React from 'react'
import styled, { css } from 'styled-components'
import { ReactComponent as HelpCircle } from '../../../../assets/src/lib/icons/dataplace/help-circle.svg'
import { ReactComponent as ArrowSpending } from '../../../../assets/src/lib/icons/placeme/arrowSpending.svg'

const Wrapper = styled.span`
    display: flex;
    padding: 0.25rem 0.5rem;
    border-radius: 2.5rem;
    align-items: center;
    margin-bottom: 0.125rem;
    justify-content: center;
    min-width: 2.5rem;
    width: min-content;
    
    > svg {
      margin-left: 0.25rem;
      min-width: 1rem;
    }
  `

const StyledArrow = styled(ArrowSpending)<{$direction: 'up' | 'down'}>(({
  $direction, theme: { palette },
}) => css`
  margin-right: 5px;
  color: ${palette.results.green.light};
  ${$direction === 'down' && css`
    color: ${palette.results.red.light};
    transform: rotate(180deg);
    transform-origin: center;
  `}
`)

export const calculateDirection = ({
  value, reference, fixTo,
}: {
  value: number
  reference: number
  fixTo?: number
}): ComparisonProps['direction'] => {
  if (value === reference || value === undefined || reference === undefined) return undefined
  if (fixTo) {
    value = Number(value.toFixed(fixTo))
    reference = Number(reference.toFixed(fixTo))
  }
  if (value > reference) return 'up'
  return 'down'
}

export interface ComparisonProps {
  value: string
  direction?: 'up' | 'down'
  state?: 'positive' | 'negative'
  withIcon?: boolean
  arrow?: boolean
}

export const Comparison = ({
  value,
  direction,
  state,
  withIcon = true,
  arrow,
}: ComparisonProps): JSX.Element => (
  <Wrapper>
    {arrow && direction && (
      <StyledArrow $direction={direction} />
    )}
    {state ? (state === 'positive' ? '+' : '-') : null}
    {value}
    {!arrow && withIcon && <HelpCircle />}
  </Wrapper>
)
